import angular from 'angular';
import { assign, includes, pull } from 'lodash';

let HUMAN_AVAILABILITY;

module.exports = angular.module('common.components.human-schedules.availability-group', [
])
.component('odHumansAvailabilityGroup', {
  bindings: {
    human: '=',
    availabilities: '=',
    availability: '='
  },
  template: require('./od-availability-group.jade')(),
  controller: class HumanAvailabilityGroupCtrl {
    // @ngInject
    constructor(HumanAvailability) {
      HUMAN_AVAILABILITY = HumanAvailability;
      this.resetNewGroup();
    }

    resetNewGroup() {
      this.newAvailability = new HUMAN_AVAILABILITY({
        _editing: true,
        human_id: this.human.id,
        availability_windows_attributes: [],
      });
    }

    deleteAvailability(availability) {
      availability.$delete().then(() => {
        pull(this.availabilities, availability);
      });
    }

    saveAvailability(availability, newAttributes) {
      const avail = new HUMAN_AVAILABILITY(newAttributes);
      let meth = '$save';

      if (avail.id) meth = '$update';

      avail[meth](() => {
        assign(availability, avail);
        availability._editing = false;

        if (!includes(this.availabilities, availability)) {
          this.availabilities.push(availability);
        }
        this.resetNewGroup();
      });
    }
  }
}).name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/components/human-schedules/od-availability-group.js
 **/